<template>
  <router-view></router-view>
</template>

<script setup>
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/*
 * 外壳等于浏览器窗口宽（--erp-shell-w 由 Layout.clampShellToWindow 写入）。
 * 禁止顶栏菜单撑出整页横滑；宽表只在 .main-viewport 内滚。
 *
 * 注意：不要写全局 ::-webkit-scrollbar。
 * Chrome 下自定义滚动条样式常与系统条叠成「右缘双竖条」。
 */
html,
body {
  width: 100%;
  max-width: var(--erp-shell-w, 100%);
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  min-height: 100dvh;
  min-width: 0;
  margin: 0;
  overflow: hidden !important;
  overscroll-behavior: none;
  background: #f4f6f9;
}

#app {
  position: relative;
  width: 100%;
  max-width: var(--erp-shell-w, 100%);
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  min-height: 100dvh;
  min-width: 0;
  margin: 0;
  overflow: hidden !important;
  background: #f4f6f9;
}

html.erp-no-doc-scroll,
html.erp-no-doc-scroll body {
  overflow: hidden !important;
  height: 100% !important;
  max-height: 100% !important;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* 非模态工作弹窗（派工单等）：无遮罩，需明显边框便于与背景区分 */
.el-dialog.erp-nonmodal-work-dialog {
  box-shadow: 0 10px 40px rgba(15, 23, 42, 0.22);
  border: 1px solid var(--el-border-color);
}

/* Element Plus 2.11：modal=false 时必须配合 is-penetrable，否则全屏 overlay 仍拦截顶栏/菜单点击 */
.el-modal-dialog.is-penetrable {
  pointer-events: none;
}
.el-modal-dialog.is-penetrable .el-dialog,
.el-modal-dialog.is-penetrable .el-drawer {
  pointer-events: auto;
}
</style>
